/**
 * Auto-synced from dentrist-app-backend lang/{locale}/responses.php
 */
export const API_MESSAGE_VARIANTS = {
  'api.errors.already_taken': [
    'The email has already been taken.',
    'The username has already been taken.',
    'This email is already registered.',
    'This username is already taken.',
  ],
  'api.errors.asset_created': [
    'Asset created',
  ],
  'api.errors.asset_deleted': [
    'Asset deleted',
  ],
  'api.errors.asset_list_retrieved': [
    'Assets retrieved',
  ],
  'api.errors.asset_not_found': [
    'Asset not found',
  ],
  'api.errors.asset_retrieved': [
    'Asset retrieved',
  ],
  'api.errors.asset_updated': [
    'Asset updated',
  ],
  'api.errors.backoffice_access_denied': [
    'This account cannot access the backoffice portal.',
    'لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.',
  ],
  'api.errors.backoffice_token_required': [
    'A valid backoffice session token is required.',
    'مطلوب رمز جلسة صالح لصفحة دخول الإدارة.',
  ],
  'api.errors.branch_created': [
    'Branch created',
  ],
  'api.errors.branch_deleted': [
    'Branch deleted',
  ],
  'api.errors.branch_list_retrieved': [
    'Branches retrieved',
  ],
  'api.errors.branch_not_found': [
    'Branch not found',
  ],
  'api.errors.branch_retrieved': [
    'Branch retrieved',
  ],
  'api.errors.branch_updated': [
    'Branch updated',
  ],
  'api.errors.client_created': [
    'Client created',
  ],
  'api.errors.client_delete_blocked': [
    'This client cannot be deleted because it is associated with one or more delivery centers.',
  ],
  'api.errors.client_deleted': [
    'Client deleted',
  ],
  'api.errors.client_list_retrieved': [
    'Clients retrieved',
  ],
  'api.errors.client_not_found': [
    'Client not found',
  ],
  'api.errors.client_retrieved': [
    'Client retrieved',
  ],
  'api.errors.client_settings_no_client_assigned': [
    'No client is assigned to your account.',
  ],
  'api.errors.client_updated': [
    'Client updated',
  ],
  'api.errors.color_created': [
    'Color created',
  ],
  'api.errors.color_delete_blocked': [
    'This color cannot be deleted because it is assigned to one or more formulas.',
  ],
  'api.errors.color_deleted': [
    'Color deleted',
  ],
  'api.errors.color_list_retrieved': [
    'Colors retrieved',
  ],
  'api.errors.color_not_found': [
    'Color not found',
  ],
  'api.errors.color_retrieved': [
    'Color retrieved',
  ],
  'api.errors.color_updated': [
    'Color updated',
  ],
  'api.errors.common_backoffice_access_denied': [
    'This account cannot access the backoffice portal.',
  ],
  'api.errors.common_backoffice_token_required': [
    'A valid backoffice session token is required.',
  ],
  'api.errors.common_contact_admin_to_reset_password': [
    'If this account has no email, contact your lab administrator to reset your password.',
  ],
  'api.errors.common_invalid_credentials': [
    'Invalid credentials',
  ],
  'api.errors.common_invalid_current_password': [
    'Current password is invalid',
  ],
  'api.errors.common_locale_updated': [
    'Locale updated',
  ],
  'api.errors.common_login_success': [
    'Login successful',
  ],
  'api.errors.common_logout_success': [
    'Logout successful',
  ],
  'api.errors.common_password_reset_link_sent': [
    'If an account exists for that email, a password reset link has been sent.',
  ],
  'api.errors.common_password_reset_success': [
    'Your password has been reset. You can now log in.',
  ],
  'api.errors.common_password_updated': [
    'Password updated',
  ],
  'api.errors.common_profile_updated': [
    'Profile updated',
  ],
  'api.errors.common_payload_too_large': [
    'The uploaded file is too large. Please use files up to 20 MB.',
    'الملف المرفوع كبير جدًا. يرجى استخدام ملفات بحجم 20 ميجابايت كحد أقصى.',
  ],
  'api.errors.common_stats_loaded': [
    'Statistics loaded successfully',
  ],
  'api.errors.common_success': [
    'Operation completed successfully',
  ],
  'api.errors.common_unauthenticated': [
    'Unauthenticated',
  ],
  'api.errors.common_use_email_to_reset_password': [
    'This account has an email address. Use the email form to receive a reset link.',
  ],
  'api.errors.common_user_created': [
    'User created',
  ],
  'api.errors.common_user_login_success': [
    'User logged in successfully',
  ],
  'api.errors.common_user_logout_success': [
    'User logged out successfully',
  ],
  'api.errors.common_validation_error': [
    'Validation failed',
  ],
  'api.errors.common_vendor_access_denied': [
    'Backoffice accounts cannot access the vendor API.',
  ],
  'api.errors.common_vendor_mismatch': [
    'vendor_id header does not match your vendor',
  ],
  'api.errors.common_vendor_missing': [
    'User is not associated with any vendor',
  ],
  'api.errors.common_vendor_portal_only': [
    'This account must sign in through the vendor portal.',
  ],
  'api.errors.common_vendor_token_required': [
    'A valid vendor session token is required.',
  ],
  'api.errors.contact_admin_to_reset_password': [
    'If this account has no email, contact your lab administrator to reset your password.',
    'إذا لم يكن لهذا الحساب بريد إلكتروني، تواصل مع مدير المعمل لإعادة تعيين كلمة المرور.',
  ],
  'api.errors.delivery_center_created': [
    'Delivery center created',
  ],
  'api.errors.delivery_center_deleted': [
    'Delivery center deleted',
  ],
  'api.errors.delivery_center_list_retrieved': [
    'Delivery centers retrieved',
  ],
  'api.errors.delivery_center_not_found': [
    'Delivery center not found',
  ],
  'api.errors.delivery_center_retrieved': [
    'Delivery center retrieved',
  ],
  'api.errors.delivery_center_updated': [
    'Delivery center updated',
  ],
  'api.errors.expense_created': [
    'Expense created',
  ],
  'api.errors.expense_deleted': [
    'Expense deleted',
  ],
  'api.errors.expense_list_retrieved': [
    'Expenses retrieved',
  ],
  'api.errors.expense_not_found': [
    'Expense not found',
  ],
  'api.errors.expense_retrieved': [
    'Expense retrieved',
  ],
  'api.errors.expense_type_created': [
    'Expense type created',
  ],
  'api.errors.expense_type_deleted': [
    'Expense type deleted',
  ],
  'api.errors.expense_type_list_retrieved': [
    'Expense types retrieved',
  ],
  'api.errors.expense_type_not_found': [
    'Expense type not found',
  ],
  'api.errors.expense_type_retrieved': [
    'Expense type retrieved',
  ],
  'api.errors.expense_type_updated': [
    'Expense type updated',
  ],
  'api.errors.expense_updated': [
    'Expense updated',
  ],
  'api.errors.formula_type_attachment_deleted': [
    'Attachment deleted',
  ],
  'api.errors.formula_type_attachment_not_found': [
    'Attachment not found',
  ],
  'api.errors.formula_type_created': [
    'Formula type created',
    'تم إنشاء نوع التركيبة',
    'تم إنشاء نوع المادة',
  ],
  'api.errors.formula_type_delete_blocked': [
    'Formula type cannot be deleted because it is in use',
    'لا يمكن حذف نوع التركيبة لأنه قيد الاستخدام',
    'لا يمكن حذف نوع المادة لأنه قيد الاستخدام',
  ],
  'api.errors.formula_type_delete_failed': [
    'Failed to delete formula type',
    'فشل حذف نوع التركيبة',
    'فشل حذف نوع المادة',
  ],
  'api.errors.formula_type_deleted': [
    'Formula type deleted',
    'تم حذف نوع التركيبة',
    'تم حذف نوع المادة',
  ],
  'api.errors.formula_type_list_retrieved': [
    'Formula types retrieved',
    'تم استرجاع أنواع التركيبات',
    'تم استرجاع أنواع المواد',
  ],
  'api.errors.formula_type_not_found': [
    'Formula type not found',
    'نوع التركيبة غير موجود',
    'نوع المادة غير موجود',
  ],
  'api.errors.formula_type_restore_not_found': [
    'Formula type to restore not found',
    'نوع التركيبة المراد استعادته غير موجود',
    'نوع المادة المراد استعادته غير موجود',
  ],
  'api.errors.formula_type_restored': [
    'Formula type restored',
    'تم استعادة نوع التركيبة',
    'تم استعادة نوع المادة',
  ],
  'api.errors.formula_type_retrieved': [
    'Formula type retrieved',
    'تم استرجاع نوع التركيبة',
    'تم استرجاع نوع المادة',
  ],
  'api.errors.formula_type_updated': [
    'Formula type updated',
    'تم تحديث نوع التركيبة',
    'تم تحديث نوع المادة',
  ],
  'api.errors.invalid_credentials': [
    'Invalid credentials',
    'بيانات اعتماد غير صحيحة',
    'These credentials do not match our records.',
    'بيانات الدخول غير صحيحة.',
  ],
  'api.errors.invalid_current_password': [
    'Current password is invalid',
    'كلمة المرور الحالية غير صحيحة',
  ],
  'api.errors.invoice_canceled': [
    'Invoice canceled',
  ],
  'api.errors.invoice_cannot_cancel_paid': [
    'Cannot cancel a paid invoice',
  ],
  'api.errors.invoice_cannot_delete_paid': [
    'Paid invoices cannot be deleted',
  ],
  'api.errors.invoice_cannot_update_paid': [
    'Paid invoices cannot be updated. Undo the payment or refund the invoice first.',
  ],
  'api.errors.invoice_created': [
    'Invoice created',
  ],
  'api.errors.invoice_deleted': [
    'Invoice deleted',
  ],
  'api.errors.invoice_email_queued': [
    'Invoice email has been queued for delivery',
  ],
  'api.errors.invoice_email_sent': [
    'Invoice sent via email',
  ],
  'api.errors.invoice_list_retrieved': [
    'Invoices retrieved',
  ],
  'api.errors.invoice_mark_paid_undone': [
    'Invoice payment undone; invoice restored to unpaid',
  ],
  'api.errors.invoice_marked_paid': [
    'Invoice marked as paid',
  ],
  'api.errors.invoice_not_found': [
    'Invoice not found',
  ],
  'api.errors.invoice_refunded': [
    'Invoice refunded and credited to client wallet',
  ],
  'api.errors.invoice_retrieved': [
    'Invoice retrieved',
  ],
  'api.errors.invoice_updated': [
    'Invoice updated',
  ],
  'api.errors.invoice_whatsapp_ready': [
    'Invoice ready to send via WhatsApp',
  ],
  'api.errors.locale_updated': [
    'Locale updated',
    'تم تحديث اللغة',
  ],
  'api.errors.login_success': [
    'Login successful',
    'تم تسجيل الدخول بنجاح',
  ],
  'api.errors.logout_success': [
    'Logout successful',
    'تم تسجيل الخروج بنجاح',
  ],
  'api.errors.money_transfer_channel_created': [
    'Money transfer channel created',
  ],
  'api.errors.money_transfer_channel_deleted': [
    'Money transfer channel deleted',
  ],
  'api.errors.money_transfer_channel_list_retrieved': [
    'Money transfer channels retrieved',
  ],
  'api.errors.money_transfer_channel_not_found': [
    'Money transfer channel not found',
  ],
  'api.errors.money_transfer_channel_retrieved': [
    'Money transfer channel retrieved',
  ],
  'api.errors.money_transfer_channel_updated': [
    'Money transfer channel updated',
  ],
  'api.errors.order_attachment_deleted': [
    'Attachment deleted',
  ],
  'api.errors.order_attachment_not_found': [
    'Attachment not found',
  ],
  'api.errors.order_cancelled': [
    'Order cancelled',
  ],
  'api.errors.order_cannot_delete_paid_invoice': [
    'Cannot delete an order that is attached to a paid invoice.',
  ],
  'api.errors.order_cannot_edit_has_invoice': [
    'Orders attached to an invoice cannot be edited.',
  ],
  'api.errors.order_cannot_cancel_has_invoice': [
    'This order is attached to an invoice. Detach it from the invoice first, then cancel it.',
  ],
  'api.errors.order_cannot_change_operational_fields': [
    'Technician, courier, and status cannot be changed while the order is cancelled, in dispute, or on hold.',
  ],
  'api.errors.order_cannot_edit_status': [
    'Orders that are finished or delivered cannot be edited.',
  ],
  'api.errors.order_cannot_update_paid_invoice': [
    'This order belongs to a paid invoice and cannot be updated. Refund the invoice first.',
  ],
  'api.errors.order_courier_assigned': [
    'Courier assigned to order',
  ],
  'api.errors.order_created': [
    'Order created',
  ],
  'api.errors.order_deleted': [
    'Order deleted',
  ],
  'api.errors.order_formulas_detached': [
    'Formulas removed from the order successfully',
  ],
  'api.errors.order_invalid_for_invoice': [
    'One or more orders cannot be attached to invoice due to status',
  ],
  'api.errors.order_list_retrieved': [
    'Orders retrieved',
  ],
  'api.errors.order_not_found': [
    'Order not found',
  ],
  'api.errors.order_restored': [
    'Order restored',
  ],
  'api.errors.order_retrieved': [
    'Order retrieved',
  ],
  'api.errors.order_status_changed': [
    'Order status changed',
  ],
  'api.errors.order_technician_assigned': [
    'Technician assigned to order',
  ],
  'api.errors.order_updated': [
    'Order updated',
  ],
  'api.errors.page_created': [
    'Page created',
  ],
  'api.errors.page_deleted': [
    'Page deleted',
  ],
  'api.errors.page_not_found': [
    'Page not found',
  ],
  'api.errors.page_retrieved': [
    'Page retrieved',
  ],
  'api.errors.page_updated': [
    'Page updated',
  ],
  'api.errors.password_reset_link_sent': [
    'If an account exists for that email, a password reset link has been sent.',
    'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
  ],
  'api.errors.password_reset_success': [
    'Your password has been reset. You can now log in.',
    'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
  ],
  'api.errors.password_updated': [
    'Password updated',
    'تم تحديث كلمة المرور',
  ],
  'api.errors.payment_method_created': [
    'Payment method created',
  ],
  'api.errors.payment_method_deleted': [
    'Payment method deleted',
  ],
  'api.errors.payment_method_list_retrieved': [
    'Payment methods retrieved',
  ],
  'api.errors.payment_method_not_found': [
    'Payment method not found',
  ],
  'api.errors.payment_method_retrieved': [
    'Payment method retrieved',
  ],
  'api.errors.payment_method_updated': [
    'Payment method updated',
  ],
  'api.errors.permission_all_retrieved': [
    'Permissions retrieved',
  ],
  'api.errors.permission_assigned': [
    'Permission assigned to user',
  ],
  'api.errors.permission_denied': [
    'You do not have permission to perform this action',
  ],
  'api.errors.permission_revoked': [
    'Permission revoked from user',
  ],
  'api.errors.permission_synced': [
    'Permissions synced successfully',
  ],
  'api.errors.permission_user_retrieved': [
    'User permissions retrieved',
  ],
  'api.errors.profile_updated': [
    'Profile updated',
    'تم تحديث الملف الشخصي',
  ],
  'api.errors.request_failed': [
    'Something went wrong',
    'Unable to login',
    'Request failed',
    'حدث خطأ ما',
  ],
  'api.errors.role_created': [
    'Role created',
  ],
  'api.errors.role_deleted': [
    'Role deleted',
  ],
  'api.errors.role_list_retrieved': [
    'Roles retrieved',
  ],
  'api.errors.role_retrieved': [
    'Role retrieved',
  ],
  'api.errors.role_updated': [
    'Role updated',
  ],
  'api.errors.setting_created': [
    'Setting created',
  ],
  'api.errors.setting_deleted': [
    'Setting deleted',
  ],
  'api.errors.setting_list_retrieved': [
    'Settings retrieved',
  ],
  'api.errors.setting_not_found': [
    'Setting not found',
  ],
  'api.errors.setting_retrieved': [
    'Setting retrieved',
  ],
  'api.errors.setting_updated': [
    'Setting updated',
  ],
  'api.errors.stats_loaded': [
    'Statistics loaded successfully',
    'تم تحميل الإحصائيات بنجاح',
  ],
  'api.errors.subscription_activated': [
    'Subscription activated successfully. Vendor created and invitation email queued.',
  ],
  'api.errors.subscription_activation_failed': [
    'Failed to activate subscription.',
  ],
  'api.errors.subscription_admin_email_taken': [
    'A user with this admin email already exists.',
  ],
  'api.errors.subscription_admin_type_missing': [
    'Vendor admin user type is not configured.',
  ],
  'api.errors.subscription_already_active': [
    'This subscription is already active.',
  ],
  'api.errors.subscription_created': [
    'Subscription request submitted successfully.',
  ],
  'api.errors.subscription_list_retrieved': [
    'Subscription plans retrieved successfully.',
  ],
  'api.errors.subscription_missing_signup_data': [
    'Subscription is missing vendor or admin signup data.',
  ],
  'api.errors.subscription_not_found': [
    'Subscription not found.',
  ],
  'api.errors.subscription_plan_activated': [
    'Subscription plan activated successfully.',
  ],
  'api.errors.subscription_plan_deactivated': [
    'Subscription plan deactivated successfully.',
  ],
  'api.errors.subscription_plan_not_found': [
    'Subscription plan not found.',
  ],
  'api.errors.subscription_plan_retrieved': [
    'Subscription plan retrieved successfully.',
  ],
  'api.errors.subscription_plan_updated': [
    'Subscription plan updated successfully.',
  ],
  'api.errors.subscription_subscriptions_list_retrieved': [
    'Subscriptions retrieved successfully.',
  ],
  'api.errors.success': [
    'Operation completed successfully',
    'تمت العملية بنجاح',
  ],
  'api.errors.transaction_created': [
    'Transaction created',
  ],
  'api.errors.transaction_deleted': [
    'Transaction deleted',
  ],
  'api.errors.transaction_list_retrieved': [
    'Transactions retrieved',
  ],
  'api.errors.transaction_not_found': [
    'Transaction not found',
  ],
  'api.errors.transaction_retrieved': [
    'Transaction retrieved',
  ],
  'api.errors.transaction_updated': [
    'Transaction updated',
  ],
  'api.errors.unauthenticated': [
    'Unauthenticated',
    'غير مصرح لك',
  ],
  'api.errors.unit_created': [
    'Unit created',
  ],
  'api.errors.unit_deleted': [
    'Unit deleted',
  ],
  'api.errors.unit_list_retrieved': [
    'Units retrieved',
  ],
  'api.errors.unit_not_found': [
    'Unit not found',
  ],
  'api.errors.unit_retrieved': [
    'Unit retrieved',
  ],
  'api.errors.unit_updated': [
    'Unit updated',
  ],
  'api.errors.use_email_to_reset_password': [
    'This account has an email address. Use the email form to receive a reset link.',
    'هذا الحساب مرتبط ببريد إلكتروني. استخدم نموذج البريد لإرسال رابط إعادة التعيين.',
  ],
  'api.errors.user_already_verified': [
    'User is already verified',
  ],
  'api.errors.user_cannot_delete_self': [
    'You cannot delete yourself',
  ],
  'api.errors.user_cannot_reset_own_password': [
    'You cannot reset your own password this way. Use the profile page or ask another admin.',
  ],
  'api.errors.user_client_required_for_dentist': [
    'Dentist users must be assigned to a client.',
  ],
  'api.errors.user_created': [
    'User created',
    'تم إنشاء المستخدم',
    'User created successfully',
  ],
  'api.errors.user_delete_blocked': [
    'This user cannot be deleted because it is associated with existing records.',
  ],
  'api.errors.user_deleted': [
    'User deleted successfully',
  ],
  'api.errors.user_email_required_for_invitation': [
    'This user has no email address, so an invitation cannot be sent.',
  ],
  'api.errors.user_invalid_token': [
    'Invalid invitation token',
  ],
  'api.errors.user_invitation_completed': [
    'Account setup completed successfully',
  ],
  'api.errors.user_invitation_email_failed': [
    'Could not send invitation email. Check mail configuration and try again.',
  ],
  'api.errors.user_invitation_expired': [
    'Invitation has expired',
  ],
  'api.errors.user_invitation_link_retrieved': [
    'Invitation link retrieved successfully',
  ],
  'api.errors.user_invitation_queued': [
    'Invitation email has been queued for delivery',
  ],
  'api.errors.user_invitation_sent': [
    'Invitation email sent successfully',
  ],
  'api.errors.user_invitation_token_regenerated': [
    'Invitation token regenerated successfully',
  ],
  'api.errors.user_invitation_token_requires_regeneration': [
    'Invitation token must be regenerated',
  ],
  'api.errors.user_invitation_valid': [
    'Invitation token is valid',
  ],
  'api.errors.user_list_retrieved': [
    'Users retrieved',
  ],
  'api.errors.user_login_success': [
    'User logged in successfully',
    'تم تسجيل دخول المستخدم بنجاح',
  ],
  'api.errors.user_logout_success': [
    'User logged out successfully',
    'تم تسجيل خروج المستخدم بنجاح',
  ],
  'api.errors.user_no_invitation_token': [
    'No invitation token found for this user',
  ],
  'api.errors.user_not_found': [
    'User not found',
  ],
  'api.errors.user_retrieved': [
    'User retrieved',
  ],
  'api.errors.user_temporary_password_reset': [
    'Password was reset to the temporary password. Share it with the user so they can log in and change it.',
  ],
  'api.errors.user_type_not_found': [
    'User type not found',
  ],
  'api.errors.user_types_retrieved': [
    'User types retrieved',
  ],
  'api.errors.user_updated': [
    'User updated',
  ],
  'api.errors.validation_error': [
    'Validation failed',
    'فشلت عملية التحقق من الحقول',
    'Validation error',
    'فشلت عملية التحقق من الحقols',
    'خطأ في التحقق من البيانات',
  ],
  'api.errors.vendor_access_denied': [
    'Backoffice accounts cannot access the vendor API.',
    'حسابات الإدارة لا يمكنها الوصول إلى واجهة المعمل.',
  ],
  'api.errors.vendor_created': [
    'Vendor created',
  ],
  'api.errors.vendor_deleted': [
    'Vendor deleted',
  ],
  'api.errors.vendor_list_retrieved': [
    'Vendors retrieved',
  ],
  'api.errors.vendor_mismatch': [
    'vendor_id header does not match your vendor',
    'معرّف المعمل في الترويسة لا يطابق المعمل الخاص بك',
  ],
  'api.errors.vendor_missing': [
    'User is not associated with any vendor',
    'المستخدم غير مرتبط بأي معمل',
  ],
  'api.errors.vendor_not_found': [
    'Vendor not found',
  ],
  'api.errors.vendor_portal_only': [
    'This account must sign in through the vendor portal.',
    'يجب تسجيل الدخول عبرصفحة دخول المعمل.',
  ],
  'api.errors.vendor_retrieved': [
    'Vendor retrieved',
  ],
  'api.errors.vendor_token_required': [
    'A valid vendor session token is required.',
    'مطلوب رمز جلسة صالح لصفحة دخول المعمل.',
  ],
  'api.errors.vendor_updated': [
    'Vendor updated',
  ],
  'api.errors.wallet_list_retrieved': [
    'Wallets retrieved',
  ],
  'api.errors.wallet_not_found': [
    'Wallet not found',
  ],
  'api.errors.wallet_retrieved': [
    'Wallet retrieved',
  ],
  'api.errors.wallet_transaction_not_found': [
    'Wallet log entry not found',
    'سجل المحفظة غير موجود',
  ],
  'api.errors.wallet_transaction_date_updated': [
    'Wallet log date updated',
    'تم تحديث تاريخ سجل المحفظة',
  ],
  'api.errors.wallet_transaction_reverted': [
    'Wallet recharge reverted',
    'تم التراجع عن شحن المحفظة',
  ],
  'api.errors.wallet_transaction_not_revertable': [
    'Only wallet recharges can be reverted',
    'يمكن التراجع عن عمليات شحن المحفظة فقط',
  ],
  'api.errors.wallet_transaction_already_reverted': [
    'This wallet recharge has already been reverted',
    'تم التراجع عن عملية الشحن هذه مسبقاً',
  ],
  'api.errors.wallet_revert_insufficient_balance': [
    'The wallet balance is lower than the recharge amount, so it cannot be reverted',
    'رصيد المحفظة أقل من مبلغ الشحن، لذلك لا يمكن التراجع عنه',
  ],
};

const LOOKUP = Object.entries(API_MESSAGE_VARIANTS).reduce((acc, [key, items]) => {
  items.forEach((variant) => {
    acc[normalizeApiMessage(variant)] = key;
  });
  return acc;
}, {});

const PATTERN_RULES = [
  { pattern: /already been taken|already registered|مستخدم بالفعل|مسجل بالفعل/i, key: 'api.errors.already_taken' },
  { pattern: /invalid credentials|credentials do not match|بيانات (الدخول|الاعتماد)/i, key: 'api.errors.invalid_credentials' },
  { pattern: /validation (failed|error)|التحقق/i, key: 'api.errors.validation_error' },
  { pattern: /permission|صلاحية/i, key: 'api.errors.permission_denied' },
  { pattern: /unauthenticated|غير مصرح/i, key: 'api.errors.unauthenticated' },
  { pattern: /not found|غير موجود/i, key: 'api.errors.not_found' },
];

export function normalizeApiMessage(message) {
  return String(message ?? '')
    .trim()
    .toLowerCase()
    .replace(/\.$/, '');
}

export function resolveApiMessageKey(message) {
  const normalized = normalizeApiMessage(message);
  if (!normalized) return null;
  if (LOOKUP[normalized]) return LOOKUP[normalized];
  for (const rule of PATTERN_RULES) {
    if (rule.pattern.test(message)) return rule.key;
  }
  return null;
}
